<template>
  <div
      v-if="user"
      class="d-inline-flex align-items-center justify-content-center rounded-circle bg-info text-white"
      :title="user.email"
      :style="myStyle">
    <span class="bi bi-person-fill fw-bold" :style="fontStyle" :title="initials"></span>
  </div>
</template>

<script setup>
  import { computed, defineProps } from "vue";``

  const props = defineProps(['user','size'])

  const myStyle = computed(() => {
    if (!props.size || !parseInt(props.size)) {
      return `width: 35px; height: 35px;`
    }
    return `width: ${parseInt(props.size)}px; height: ${parseInt(props.size)}px;`
  })

  const fontStyle = computed(() => {
    if (!props.size || !parseInt(props.size)) {
      return `font-size: ${parseInt(35*.75)} px; line-height:1; margin:0; padding:0;`
    }
    return `font-size: ${parseInt(props.size * .75)}px;  line-height:1; margin:0; padding:0;`
  })

  const initials = computed(() => {
    const parts = props.user.email.split("@");
    return parts[0][0].toUpperCase();
  })
</script>

<style lang="scss" scoped>

</style>
